export default __webpack_public_path__ + "static/media/Care05.879e5829.png";